<!-- 薪资发放 -->
<template>
    <section>
        <section class="search-container">
            <a-form layout="inline" class="m-t-14">
                <a-form-item label="单位名称">
                    <a-select showSearch option-filter-prop="children" class="search-select" placeholder="全部" v-model="searchInfo.companyId">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option v-for="item in companyMap" :key="item.id" :value="item.id">{{item.companyName}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="劳务班组">
                    <a-select showSearch option-filter-prop="children" class="search-select" placeholder="全部" v-model="searchInfo.teamId">
                        <a-select-option v-for="item in teamMap" :key="item.id" :value="item.id">{{item.teamName}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="结算类型">
                    <a-select class="search-select" placeholder="全部" v-model="searchInfo.type">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option v-for="item in typeList" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="状态">
                    <a-select class="search-select" placeholder="全部" v-model="searchInfo.uploadStatus">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option value="0">未支付</a-select-option>
                        <a-select-option value="1">已支付</a-select-option>
                    </a-select>
                </a-form-item>
               
                <a-form-item label="人员姓名">
                    <a-input class="search-input" placeholder="请输入" v-model="searchInfo.personnelName"  />
                </a-form-item>
                <a-form-item>
                    <a-input-group compact>
                        <a-select style="width: 60px;margin-right:2px" v-model="dataType" @change="changeDateType">
                            <a-select-option :value="1">年</a-select-option>
                            <a-select-option :value="2">月</a-select-option>
                        </a-select>
                        <a-date-picker v-if="dataType == 1" mode="year" v-model="searchInfo.payYear" format='YYYY' :open="yearShowOne" @openChange="openChangeYear" @panelChange="panelChangeYear" class="search-select" />
                        <a-month-picker v-else placeholder="月" v-model="searchInfo.payMonth" format='YYYY-MM' class="search-select" />
                    </a-input-group>
                    
                </a-form-item>
                
                <a-form-item>
                    <a-button type="primary" class="m-r-8" @click="search"><a-icon type="search" />查询</a-button>
                    <a-button @click="reset"><a-icon type="reload" />重置</a-button>
                </a-form-item>
            </a-form>
        </section>
        
        <section class="list-single-container" v-if="listMap.length">
            <a-row class="m-t-18 total-data-wrap">
                <a-col class="item">
                    <span class="key">人员数量：</span>
                    <span class="val">{{totalStatistics.personCount}}</span>
                </a-col>
                <a-col class="item">
                    <span class="key">应发工资(元)：</span>
                    <span class="val">{{totalStatistics.payGrossAmount}}</span>
                </a-col>
                <a-col class="item">
                    <span class="key">实发工资(元)：</span>
                    <span class="val">{{totalStatistics.payNetAmount}}</span>
                </a-col>    
            </a-row>
            <a-row class="list-border list-item m-t-10" v-for="(item,key) in listMap" :key="key">
                <a-row class="action-btn-group">
                    <a-row>
                        <a-button @click="showPreviewImageModal(item.uploadPhoto)" size="small" class="m-b-8" v-if="item.uploadPhoto && item.uploadPhoto.length">支付凭证</a-button>
                        <!-- <span @click="sid = item.id" v-else style="display:inline-block" class="m-b-8">
                            <upload @func="updateCompanyPaySalaryTotal" :node="{type:2,text:'上传凭证',size:'small'}" :accept="['.jpg','.png','.pdf']" />
                        </span> -->
                        <a-button @click="showUploadModal(item)" v-else  class="m-b-8">上传凭证</a-button>
                        <router-link class="m-b-8" :to="{path:'/pcms/salary/grant/details',query:{id:item.id}}"><a-button size="small">查看</a-button></router-link>
                        <router-link v-if="!(item.uploadPhoto && item.uploadPhoto.length)" class="m-b-8" :to="{path:'/pcms/salary/grant/edit',query:{id:item.id}}"><a-button size="small">编辑</a-button></router-link>
                        <a-popconfirm class="m-b-8" title="确定删除该薪资?" @confirm="deleteItem(item.id)"><a-button size="small">删除</a-button></a-popconfirm>
                        
                        
                    </a-row>
                </a-row>
               
                <a-row v-if="item.payType == 1">
                     <p class="list-title">{{item.companyName}}
                        (<span>单位发放</span>)
                    </p>
                    <a-row class="m-b-10">
                        <a-col :span="7">
                            <span class="key">结算类型：</span>
                            <span class="val">{{item.typeName}}</span>
                        </a-col>
                        <a-col :span="7" >
                            <span class="key">结算状态：</span>
                            <span :style="{color:(item.uploadPhoto && item.uploadPhoto.length) ? '#52C41A' :'#FF555E'}">{{(item.uploadPhoto && item.uploadPhoto.length) ? '已支付' : '未支付'}}</span>
                        </a-col>
                    </a-row>
                    <a-row class="m-b-10">
                        <a-col :span="7">
                            <span class="key">时间范围：</span>
                            <span class="val">{{item.payYear+'-'+item.payMonth}}</span>
                        </a-col>
                        <a-col :span="7">
                            <span class="key">应发工资：</span>
                            <span class="val">{{item.payGrossAmount || 0}}元</span>
                        </a-col>
                        <!-- <a-col :span="7">实发工资：{{item.payNetAmount || 0}}元</a-col> -->
                    </a-row>
                    <a-row class="m-b-10">
                        <a-col :span="7">
                            <span class="key">单位人数：</span>
                            <span class="val">{{item.personnelCount}}</span>
                        </a-col>
                        <a-col :span="7">
                            <span class="key">发放时间：</span>
                            <span class="val">{{item.createTime}}</span>
                        </a-col>
                    </a-row>
                </a-row>
                <a-row v-else-if="item.payType == 2">
                    <p>{{item.teamName}}
                        (<span>班组发放</span>)
                    </p>
                    <a-row class="m-b-10">
                        <a-col :span="7">结算类型：{{item.typeName}}</a-col>
                        <a-col :span="7">班组人数：{{item.personnelCount || 0}}</a-col>
                        <a-col :span="7" >结算状态：<span :style="{color:(item.uploadPhoto && item.uploadPhoto.length) ? '#52C41A' :'#FF555E'}">{{(item.uploadPhoto && item.uploadPhoto.length) ? '已支付' : '未支付'}}</span></a-col>
                    </a-row>
                    <a-row class="m-b-10">
                        <a-col  :span="7">所属单位：{{item.companyName}}</a-col>
                        <a-col :span="7">应发工资：{{item.payGrossAmount || 0}}元</a-col>
                        <!-- <a-col :span="7">实发工资：{{item.payNetAmount || 0}}元</a-col> -->
                        
                    </a-row>
                    <a-row class="m-b-10">
                        <a-col :span="7">时间范围：{{item.payYear+'-'+item.payMonth}}</a-col>
                        <a-col :span="7">发放时间：{{item.createTime}}</a-col>
                    </a-row>
                </a-row>
                <a-row v-else>
                    <p>{{item.personnelName}}
                        (<span>个人发放</span>)
                    </p>
                    <a-row class="m-b-10">
                        <a-col :span="7">结算类型：{{item.typeName}}</a-col>
                        <a-col :span="7" >结算状态：<span :style="{color:(item.uploadPhoto && item.uploadPhoto.length) ? '#52C41A' :'#FF555E'}">{{(item.uploadPhoto && item.uploadPhoto.length) ? '已支付' : '未支付'}}</span></a-col>
                    </a-row>
                    <a-row class="m-b-10">
                        <a-col :span="7">所属单位：{{item.companyName}}</a-col>
                        <a-col :span="7">应发工资：{{item.payGrossAmount || 0}}元</a-col>
                        <!-- <a-col :span="7">实发工资：{{item.payNetAmount || 0}}元</a-col> -->
                    </a-row>
                    <a-row class="m-b-10">
                        <a-col :span="7">时间范围：{{item.payYear+'-'+item.payMonth}}</a-col>
                        <a-col class="m-b-10" :span="7">发放时间：{{item.createTime}}</a-col>
                    </a-row>
                </a-row>
            </a-row>
        </section>
        <empty v-else :height="330" />
        <section class="pagination-container">
            <a-pagination 
            size="default" 
            :current="pageNum" 
            :total="total" 
            :hideOnSinglePage="true" 
            :show-total="(total) => `共${total}条`"
            :showQuickJumper="true"
		    :showSizeChanger="false"
            @change="changePageNum" />
        </section>
        <!-- 图片预览 -->
        <a-modal centered width="800px" class="modal-container" title="图片预览" v-model="previewImageModal.visible" :footer="false" :destroyOnClose="true">
            <a-row class="text-center" type="flex" justify="center" >
                <img style="background:#FFF;width:80%"  :src="previewImageModal.url" alt="">
            </a-row>
        </a-modal>
        <!-- 上传凭证 -->
        <a-modal centered width="600px" class="modal-container" title="上传凭证" v-model="uploadModalVisible" :footer="false" :destroyOnClose="true">
            <a-form :form="form">
               
               <a-form-item :label-col="{span:5}" :wrapper-col="{span:18}" label="实发金额(元)">
                   <a-input  v-decorator="['payNetAmount',{rules:[{required:true,message:'请输入实发金额'},{validator:validator.moneyReg,message:'请输入数字'}]}]" placeholder="请选择" />
               </a-form-item>
               <a-form-item :label-col="{span:5}" :wrapper-col="{span:18}" label="附件">
                   <a-row type="flex">
                        <a-row class="upload-preview-wrap">
                            <a v-for="(item,key) in fileLists" :key="key" class="file-item m-r-10">
                                <a-avatar  shape="square" :size="100" :src="item.url" />
                                <a class="close-icon" title="删除" @click="deleteFile(item)"><a-icon type="close"></a-icon></a>
                            </a>
                        </a-row>
                        <upload v-decorator="['uploadPhoto',{rules:[{required:true,message:'请上附件'}]}]" style="display:inline-block;width:100px" @func="getFiles" :node="{type:3,text:'上传'}" :accept="['.png','.jpg']"/>
                    </a-row>
               </a-form-item>
               <a-row class="form-btn-group">
                   <a-button class="btn-save"  @click="submit"><a-icon type="save" />确定</a-button>
                   <a-button class="btn-cancel"  @click="uploadModalVisible = false">取消</a-button>
               </a-row>
            </a-form>
        </a-modal>
    </section>
</template>

<script>
import upload from '@/components/upload'
import empty from '@/components/empty'
import validator from '@/until/validator'
export default {
    data(){
        return{
            validator,
            companyMap:[],
            teamMap:[],
            typeList:[],
            searchInfo:{
                payYear:null,
                payMonth:null
            },
            total:0,
            pageNum:1,
            listMap:[],
            sid:'',
            previewImageModal:{
                visible:false,
                title:'查看图片',
                url:''
            },
            yearShowOne:false,
            dataType:1,
            totalStatistics:{},
            fileLists:[],
            uploadModalVisible:false

        }
    },
    components:{upload,empty},
    beforeCreate(){
        this.form = this.$form.createForm(this)
    },
    created(){
       this.init() 
    },
    mounted(){
        this.queryCompanyPaySalaryTotalList()
        this.queryCompanyPaySalaryTotalStatistics()
    },
    methods:{
        openChangeYear(status){
            if(status){
                this.yearShowOne =  true
            }
        },
        panelChangeYear(value){
            this.searchInfo.payYear = value
            this.yearShowOne = false
        },
        changeDateType(){
            this.searchInfo.payYear = this.dataType == 1 ? this.searchInfo.payYear : null
            this.searchInfo.payMonth = this.dataType == 2 ? this.searchInfo.payMonth : null
        },
        init(){
            this.queryCompanyPayTypeList()
            this.queryCompanyDropDownBox()
            this.queryTeamDropDownBox()
        },
        //查看支付凭证
        showPreviewImageModal(file){
            this.previewImageModal.url = file[0].url
            this.previewImageModal.visible = true
        },
        //结算类型下拉
        queryCompanyPayTypeList(){
            this.$api.queryCompanyPayTypeList({size:1000}).then(res =>{
                if(res.code === 200){
                    this.typeList = (res.data && res.data.records) || []
                }
            })
        },
        //单位下拉
        queryCompanyDropDownBox(){
            this.$api.queryCompanyDropDownBox().then(res =>{
                if(res.code === 200){
                    this.companyMap = res.data || []
                }
            })
        },
         //班组下拉
        queryTeamDropDownBox(){
            this.$api.queryTeamDropDownBox().then(res =>{
                if(res.code === 200){
                    this.teamMap = res.data || []
                }
            })
        },
        queryCompanyPaySalaryTotalStatistics(){
            this.$api.queryCompanyPaySalaryTotalStatistics().then(res =>{
                if(res.code === 200){
                    this.totalStatistics = res.data || {}
                }
            })
        },
        queryCompanyPaySalaryTotalList(){
            let params = {...this.searchInfo}
            params.current =this.pageNum
            params.payYear = this.searchInfo.payYear ? this.searchInfo.payYear.format('YYYY') : ''
            params.payMonth = this.searchInfo.payMonth ? this.searchInfo.payMonth.format('YYYY-MM') : ''
            this.$api.queryCompanyPaySalaryTotalList(params).then(res =>{
                if(res.code === 200){
                    this.listMap = (res.data && res.data.records) || []
                    this.total = (res.data && res.data.total) || 0
                    this.listMap.forEach(item =>{
                        item.uploadPhoto = item.uploadPhoto ? JSON.parse(item.uploadPhoto) : []
                    })
                }
            })
        },
        reset(){
             this.searchInfo = {
                payYear:null,
                payMonth:null
            }
            this.pageNum = 1
            this.queryCompanyPaySalaryTotalList()
        },
        search(){
            this.pageNum = 1
            this.queryCompanyPaySalaryTotalList()
        },
        changePageNum(p){
            this.pageNum = p
            this.queryCompanyPaySalaryTotalList()
        },
        deleteItem(id){
            this.$api.deleteCompanyPaySalaryTotal(id).then(res =>{
                if(res.code === 200){
                    this.queryCompanyPaySalaryTotalList()
                }
            })
        },
        showUploadModal(list){
            this.sid = list.id
            this.uploadModalVisible = true
            this.$nextTick(() =>{
                this.form.setFieldsValue({
                    payNetAmount:list.payGrossAmount
                })
            })
        },
        getFiles(list){
            this.fileLists = [list]
            this.$nextTick(() =>{
                this.form.setFieldsValue({
                    uploadPhoto:this.fileLists.length ? JSON.stringify(this.fileLists) : ''
                })
            })
        },
        deleteFile(list){
            this.fileLists = this.fileLists.filter(item => item.codeUrl !== list.codeUrl)
            this.$nextTick(() =>{
                this.form.setFieldsValue({
                    uploadPhoto:this.fileLists.length ? JSON.stringify(this.fileLists) : ''
                })
            })
        },
        //上传支付凭证提交
        submit(){
            this.form.validateFields((err,formData) =>{
                if(!err){
                    formData.id = this.sid
                    this.$api.updateCompanyPaySalaryTotal(formData).then(res =>{
                        if(res.code === 200){
                            this.uploadModalVisible = false
                            this.queryCompanyPaySalaryTotalList()
                        }
                    })
                }
            })
        },
        //上传支付凭证
        // updateCompanyPaySalaryTotal(file){
        //     let uploadPhoto = JSON.stringify([file])
        //     this.$api.updateCompanyPaySalaryTotal({id:this.sid,uploadPhoto}).then(res =>{
        //         if(res.code === 200){
        //             this.queryCompanyPaySalaryTotalList()
        //         }
        //     })
        // }
    }
}
</script>

<style lang="scss" scoped>
    .list-single-container{
        .ant-btn{
            height: 24px;
        }
    }
    
</style>